import Component from "./EmptyPlaceholder";
export default Component;
